var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasData
    ? _c(
        "div",
        { class: _vm.chartContainerClass },
        [
          _vm.height
            ? _c(
                "div",
                { key: _vm.height, style: { height: _vm.height + "px" } },
                [
                  _c("bar-horizontal-chart", {
                    attrs: {
                      "chart-data": _vm.formattedChart.chartData,
                      options: _vm.formattedChart.chartOptions,
                      plugins: _vm.formattedChart.chartPlugins,
                      height: _vm.height
                    }
                  })
                ],
                1
              )
            : _c("bar-horizontal-chart", {
                attrs: {
                  "chart-data": _vm.formattedChart.chartData,
                  options: _vm.formattedChart.chartOptions,
                  plugins: _vm.formattedChart.chartPlugins
                }
              })
        ],
        1
      )
    : _c("div", { staticClass: "alocacao-estrategica__content-empty" }, [
        _c("div", { staticClass: "text-center text-color-600" }, [
          _vm._v(" Nenhum dado disponível para exibição ")
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }